import { http, lHttp } from '@utils/interceptor'
import { ActionContext, Module } from 'vuex'
import { uid, skey, guid, isHzwApp, isRkhy, isWeixin } from '@utils/index'
import { getSelectedCityId, getBirthSlot } from '@utils/index'
import { Toast } from 'vant'
import jsCookie from 'js-cookie'

const api = {
  babyListApi: '//user.cekid.com/user/GetBabyInfo',
  // homeDataApi: '//soperationapi.haiziwang.com/soperation-api/citySite/queryTemplate.do',
  homeDataApi: '//soperationapi.cekid.com/soperation-api/citySite/queryTemplate.do',
  storeActivityApi: '//czjcapi.cekid.com/api-c/index/getNearbyStoreActivities.do',
  categoryListApi: '//soperationapi.haiziwang.com/soperation-api/citySite/queryAllChannel.do',
  // babyListApi: '//api.czj100.com/user/babyInfo',
  districtListApi: '//address.cekid.com/addressview/GetDistrictList',
  cmsDataApi: '//cms.cekid.com/publish/999/newer-yuesao-home.json',
  recommendApi: '//kbsrecommend.cekid.com/bigserver/BSRmdInShouye',
  queryCouponStatusApi: '//coc.cekid.com/user/participated',
  receiveCoupon: '//coc.cekid.com/do',
  receiveServiceCoupon: '//scouponapi.cekid.com/scoupon-api/userCoupon/sendCoupon.do', // 领取大服务券
  queryCouponChance: '//coc.cekid.com/user/chance'
}

export async function getBabyList(): Promise<any[]> {
  const result = await http.get(api.babyListApi, { params: { uid, skey }, withCredentials: true })
  const { data, errno, errmsg } = result
  if (+errno === 0 && data) {
    for (const item of data.babyInfo) {
      item.birthdiscribe = getBirthSlot(item.birthday)
    }
    return data.babyInfo
  } else {
    if (+errno === 3536) {
      //没有添加宝宝的情况
      return Promise.resolve([])
    } else {
      return Promise.reject('fail')
    }
  }
}

export async function getCategoryList(cityCode: any): Promise<any[]> {
  const result = await lHttp.get(api.categoryListApi, { params: { cityCode } })
  const { data, code, msg } = result
  if (+code === 1 && data) {
    return data
  } else {
    Toast(msg)
    return Promise.reject(msg)
  }
}

export async function getCmsData(): Promise<any> {
  const result = await http.get(api.cmsDataApi)
  const { data } = result
  return data
}

export interface HomeData {
  templateType: number
  categoryIds: string
  ads: any
  channel: any[]
  promotion: any
  custom: any
  isWaterfall: number
  tabs: any[]
  isSelfSon: number
  title: string
  dailySaleInfo: any
  customService: {
    h5Img: string
    appImg: string
    link: string
    display: string
    onOff: string
  }
  customFloors: any
}

// export async function getNetHomeData(ageFilter: number , cityId: string|number, versionType: number) : Promise<HomeData>{
//     const result = await lHttp.get(`${api.homeDataApi}`, { params: { cityId, ageFilter, versionType } })
//     const { data, code, msg } = result
//     if (+code === 1 && data ) {
//         return data
//     } else if (+code === 10002) {
//         return Promise.reject(10002)
//     } else {
//         Toast(msg)
//         return Promise.reject(msg)
//     }
// }
export interface HomeDataRequest {
  ageFilter: number
  cityId: string | number
  versionType: number
  longitude?: number
  latitude?: number
}

export async function getNetHomeData(params: HomeDataRequest): Promise<HomeData> {
  const result = await http.get(api.homeDataApi, { params: { ...params }, withCredentials: true })
  const { data, code, msg } = result
  if (+code === 1 && data) {
    return data
  } else if (+code === 10002) {
    return Promise.reject(10002)
  } else {
    Toast(msg)
    return Promise.reject(msg)
  }
}

export async function getStoreActivity(params: any) {
  const result = await http.get(api.storeActivityApi, { params, withCredentials: true })
  const { data, code } = result
  if (+code === 1 && data) {
    return data
  }
}

export async function getDistrictListByCityCode() {
  let { DistrictList = [] } = await http.get(`${api.districtListApi}?cityId=${getSelectedCityId()}`)
  DistrictList = [{ ID: '', NAME: '全城' }, ...DistrictList]
  return DistrictList
}

interface RecommendRequest {
  scene?: string //场景编码 默认传BSRmdInShouye
  version?: string //是否开启筛选功能 默认传v20210624
  uid?: string
  guid?: string
  skey?: number
  source?: number //请求来源(1:app 2:wechat 3:pc)
  pagenum?: number //分页号，从0开始（传递页码需要保证页码传入的连续性）
  pagesize?: number //分页大小 10（需要返回促销标签的场景最大限制20条每页）
  citycode?: number //当前定位或公共地址 城市编码，针对直辖市传一级城市编码，如上海市：传310000
  longitude?: string //当前定位或公共地址 经度
  latitude?: string //当前定位或公共地址 纬度
  babyage?: number //0：不限，1：孕期，2：0-36个月、3：36个月以上
  tabId?: string //推荐tab
}
interface RecommendResponse {
  errno: number
  errmsg: string
  msgid: string
  rmdlist: {
    moduleId: string
    data: any[]
  }
}

export async function getRecommend(req: RecommendRequest): Promise<RecommendResponse> {
  const cityId = getSelectedCityId()
  const source = isHzwApp() || isRkhy() ? 1 : isWeixin() ? 2 : 3
  const upar: RecommendRequest = {}
  uid && (upar.uid = uid)
  guid && (upar.guid = guid)
  skey && (upar.skey = skey)
  return http.post(
    api.recommendApi,
    {
      scene: 'BSRmdInShouye',
      version: 'v20210624',
      source,
      citycode: Number(cityId),
      ...upar,
      ...req
      // tabId: 1001 /* 测试数据 */
    },
    {
      withCredentials: true
    }
  )
}

interface IHomeState {
  str: number
  promotion: any
}

export const STORE: Module<IHomeState, any> = {
  namespaced: true,
  state: () => ({
    str: 0,
    promotion: {}
  }),
  mutations: {},
  getters: {},
  actions: {}
}
// interface CouponRequest {
//     cid: string
// }

interface CouponResponse {
  code: number
  data: { ret: boolean }
  message: string
}

// 查询用户是否领用该优惠券
export async function queryCouponStatus(cid: string): Promise<CouponResponse> {
  //   const uid = jsCookie.get('uid')
  return await http.get(api.queryCouponStatusApi, { params: { uid, cid } })
}

interface receiveCouponResponse {
  code: number
  data: any
  message: string
  msg: string
}

// 用户领童乐园券
export async function receivePlayCoupon(cid: string): Promise<receiveCouponResponse> {
  return await http.get(api.receiveCoupon, { params: { cid }, withCredentials: true })
}

// 用户领大服务券
export async function receiveBigServiceCoupon(couponId: string): Promise<receiveCouponResponse> {
  return await http.get(api.receiveServiceCoupon, { params: { couponId, uid, source: 'H5' }, withCredentials: true })
}

// 查询券可领次数
export async function getCoupon(cid: string): Promise<receiveCouponResponse> {
  return await http.get(api.queryCouponChance, { params: { cid }, withCredentials: true })
}
